<div
  *ngVar="editing$ | async as editing"
  cdkDropList
  class="subprocessors-container flex flex-col gap-5"
  (cdkDropListDropped)="changeOrder($event)"
>
  @if (editing) {
    <div class="flex flex-col self-center justify-center items-center gap-1 text-center max-w-250">
      <div class="text-2xl text-navy-70 font-bold">
        {{ buildTranslationKey('whichSubprocessorsAreDisplayed') | translate }}
      </div>
      <div class="text-2xl text-navy-70 font-normal">
        {{ buildTranslationKey('whichSubprocessorsAreDisplayedDescription') | translate }}
      </div>
    </div>

    <div
      class="flex rounded-md gap-6 py-4 px-6 shadow-sm bg-white border border-solid border-navy-50 hover:border-navy-90 cursor-pointer"
      (click)="openCustomSubprocessorSidepanel()"
    >
      <div class="flex justify-start md:justify-center items-center">
        <svg-icon class="w-12.5 h-12.5" [src]="'add-filled'"></svg-icon>
      </div>
      <div class="flex g-2.5 flex-col justify-center flex-1 text-navy-90 font-bold text-3xl">
        {{ buildTranslationKey('addSubprocessor') | translate }}
      </div>
    </div>
  }

  @for (subprocessor of subprocessors; track subprocessor.id) {
    @if (editing && subprocessor.is_visible) {
      <div
        class="trust-subprocessor-item relative"
        cdkDrag
        cdkDragLockAxis="y"
        cdkDragBoundary=".subprocessors-container"
      >
        <ng-container *ngTemplateOutlet="subprocessorItem; context: { subprocessor }"></ng-container>
        @if (editing) {
          <app-new-button
            cdkDragHandle
            class="cdk-drag-handle top-0 left-0 h-10 w-10 bg-navy-40 border border-navy-60 transform -translate-x-1/2 -translate-y-1/2"
            [svgIconPath]="'drag'"
            [isOnlyIcon]="true"
            [type]="'basic'"
            [size]="'tiny'"
          ></app-new-button>
        }
      </div>
    } @else {
      <div>
        <ng-container *ngTemplateOutlet="subprocessorItem; context: { subprocessor }"></ng-container>
      </div>
    }
  }

  <ng-template #subprocessorItem let-subprocessor="subprocessor">
    <div
      class="subprocessor flex flex-col md:flex-row rounded-md gap-6 pt-3.5 pb-5 px-6 shadow-sm bg-white border border-solid border-navy-50"
      [class.cursor-pointer]="editing"
      [class.hover:border-navy-90]="editing"
      [class.subprocessor-hidden]="!subprocessor.is_visible"
      (click)="openSubprocessorSidepanel(subprocessor)"
    >
      <div class="flex justify-start md:justify-center items-center">
        @if (subprocessor.is_custom) {
          <img class="w-12.5 subprocessor-logo" [src]="subprocessor.logo | safe: 'url'" />
        } @else {
          <svg-icon class="w-12.5 subprocessor-logo" [src]="getServiceIcon(subprocessor.id)"></svg-icon>
        }
      </div>

      <div class="flex flex-col g-2.5 justify-center flex-1">
        <div class="flex items-center">
          <div class="flex-grow">
            <div class="flex justify-start items-center font-main">
              <div class="subprocessor-title text-navy-90 font-bold text-3xl">
                {{ subprocessor.name }}
              </div>
              @if (subprocessor.location; as location) {
                <div class="subprocessor-title text-navy-90 font-normal text-base leading-none">
                  &nbsp;| {{ location }}
                </div>
              }
              @if (editing && !subprocessor.is_visible) {
                <svg-icon class="w-6 h-6 ml-3" [src]="'eye'"></svg-icon>
              }
            </div>
          </div>

          @if (editing) {
            <div class="justify-self-end">
              <app-icon-button
                class="edit-button"
                [svgIconPath]="'edit'"
                [type]="'basic'"
                [iconSize]="'small'"
              ></app-icon-button>
            </div>
          }
        </div>

        @if (subprocessor.usage; as usage) {
          <div class="mt-2 text-navy-70 text-base font-normal whitespace-pre-line">
            {{ usage }}
          </div>
        }
      </div>
    </div>
  </ng-template>
</div>
